import { render, staticRenderFns } from "./OutOrderListOrder.vue?vue&type=template&id=2c1a0a2c&scoped=true&"
import script from "./OutOrderListOrder.vue?vue&type=script&lang=js&"
export * from "./OutOrderListOrder.vue?vue&type=script&lang=js&"
import style0 from "./OutOrderListOrder.vue?vue&type=style&index=0&id=2c1a0a2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1a0a2c",
  null
  
)

export default component.exports